import { Font } from './ThemeType'

const FONTS: Font = {
    displayXXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: '62px',
        lineHeight: '150%',
    },
    displayXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: '46px',
        lineHeight: '150%',
    },
    displayL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: '34px',
        lineHeight: '150%',
    },
    displayM: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: '24px',
        lineHeight: '150%',
    },
    displayS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: '18px',
        lineHeight: '180%',
    },
    displayXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: '14px',
        lineHeight: '180%',
    },
    displayXXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: '12px',
        lineHeight: '180%',
    },
    bodyL: {
        fontFamily: '"Inter", sans-serif',
        fontSize: '18px',
        lineHeight: '180%',
    },
    bodyM: {
        fontFamily: '"Inter", sans-serif',
        fontSize: '14px',
        lineHeight: '180%',
    },
    bodyS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: '12px',
        lineHeight: '180%',
    },
    bodyXS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: '10px',
        lineHeight: '180%',
    },
}

export { FONTS }
